<template>
  <component
    :is="props.for ? 'label' : 'div'"
    :for="props.for"
    :class="[
      'absolute left-4 pl-px transform transition-all duration-200 pointer-events-none select-none',
      value
        ? 'text-xs top-2 translate-y-0'
        : '-translate-y-1/2 top-1/2 text-base',
    ]"
  >
    {{ placeholder }}
  </component>
</template>

<script setup lang="ts">
  interface Props {
    placeholder?: string;
    value?: string;
    for?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    placeholder: '',
    value: '',
  });
</script>
